var formContatti = (function () {

	function init() {
		var $formContatti = $('.form-contatti');
		
		if($formContatti.length && (ENV.isEditmode==='' || ENV.isEditmode==='false')){

			$('.form-contatti select').select2({
				allowClear: true,
			});

			$(".custom-file-upload-btn").on("click", function(e) {
				$(".original-file-input").trigger("click");
				e.preventDefault();
			});
			$(".original-file-input").on("change", function() {
				var fileName = $(this).val().split("\\").pop();
				fileName = fileName.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
				$(".custom-file-upload-label").html(fileName || "Nessun file selezionato");
			});

			$formContatti.on("submit", function(e) {
				if(!validateForm($formContatti)) {
					e.preventDefault();
					return false;
				}
			});

			if (typeof _ERRORS_TT !== "undefined"){
				showValidationErrors($formContatti);
			}
			//trigger click
			$("#upload_button").on("click", function(){
				$("#attachment_asset").trigger("click");
			});

			//show uploaded file name
			$('input[type="file"]').on("change", function(){
				$("#file_text").attr("placeholder", $(this).val().split('\\').pop());
				$("#cross_icon").removeClass("invisible");
			});

			//delete uploade file
			$("#cross_icon").on("click", function(){
				$('input[type="file"]').val('');
				$("#file_text").attr("placeholder", "");
				$(this).addClass("invisible");
			});

			handleAlreadyCustomerField($formContatti);
		}
	}

	function handleAlreadyCustomerField(currentForm){
		var alreadyCustomerContainer = $('#already-customer-field-container',currentForm)
		var licensePlateContainer = $('#license-plate-field-container',currentForm)
		var bpCodeContainer = $('#bp-code-field-container',currentForm);
		var technicalInfoFieldsetContainer = $('fieldset.technical-information-fieldset',currentForm);
		var troubleArgumentContainer = $('.troubleArgument-container',currentForm);
		var troubleArgumentRowContainer = $('.troubleArgument-row',currentForm);
		if(alreadyCustomerContainer.length>0 && (licensePlateContainer.length>0 || bpCodeContainer.length>0)){
			switchFields(alreadyCustomerContainer, licensePlateContainer, bpCodeContainer, technicalInfoFieldsetContainer, troubleArgumentContainer, troubleArgumentRowContainer);
			$('input[type=radio]',alreadyCustomerContainer).on('click', function () {
				switchFields(alreadyCustomerContainer, licensePlateContainer, bpCodeContainer, technicalInfoFieldsetContainer, troubleArgumentContainer,troubleArgumentRowContainer);
			})
		}
	}

	function switchFields (alreadyCustomerContainer, licensePlateContainer, bpCodeContainer, technicalInfoFieldsetContainer, troubleArgumentContainer, troubleArgumentRowContainer){
		var licensePlateMandatory = licensePlateContainer.data('mandatory') === 1;
		if($('#already-customer-Y',alreadyCustomerContainer).is(':checked')){
			if(bpCodeContainer.length>0){
				bpCodeContainer.removeClass('d-none');
			}
			if(licensePlateContainer.length>0 && !licensePlateMandatory){
				$('label', licensePlateContainer).html($('label', licensePlateContainer).html()+'*');
			}
            if(technicalInfoFieldsetContainer.length){
                technicalInfoFieldsetContainer.removeClass("d-none");
            }
            if(troubleArgumentContainer.length){
                troubleArgumentContainer.removeClass("d-none");
                $("input#vat_number-field", technicalInfoFieldsetContainer).val('');
            }
            if(troubleArgumentRowContainer.length)
            {
                troubleArgumentRowContainer.removeClass("flex-row-reverse");
            }


		}else{
			if(bpCodeContainer.length>0){
				bpCodeContainer.addClass('d-none');
				$("#bpcode-field",bpCodeContainer).val('');
			}
			if(licensePlateContainer.length>0 && !licensePlateMandatory){
				$('label', licensePlateContainer).html(rtrim($('label', licensePlateContainer).html(),'*'));
                $("input#licenseplate-field", licensePlateContainer).val('');
			}
            if(technicalInfoFieldsetContainer.length){
                technicalInfoFieldsetContainer.addClass("d-none");
            }
            if(troubleArgumentContainer.length){
                troubleArgumentContainer.addClass("d-none");                
                $("select#troubleArgument", troubleArgumentContainer).select2().val(null).trigger('change');
            }
            if(troubleArgumentRowContainer.length)
            {
                troubleArgumentRowContainer.addClass("flex-row-reverse");
            }
		}
	}

	function rtrim(str, ch){
		let i = str.length;
		while (i-- && str.charAt(i) === ch);
		return str.substring(0, i + 1);
	}

	function showValidationErrors(form) {
		var errorFieldLabels = [];
		var elementLowestOffest = '';
        
		$.each(_ERRORS_TT.list, function () {
			if (this != 'troubleSubArgument' && this != 'troubleCause' && this != 'role'){                
				var currentElement = $("[name="+this+"]");
				if(this == 'alreadyCustomer'){
					currentElement = currentElement.closest('#already-customer-field-container');
				}
                
				errorFieldLabels.push(currentElement.data('label').trim())

				if (elementLowestOffest === '' || (form.find("[name="+elementLowestOffest+"]").offset()>currentElement.offset()) ){
					elementLowestOffest = this;
				}
			}
		})
		form.closest('.contact_form_box').find('.form-container-error .error-container .error').html(errorFieldLabels.join(", "));



		var fieldToFocus = form.find("[name="+elementLowestOffest+"]");
		if (fieldToFocus.attr('aria-hidden') === 'true' && fieldToFocus.hasClass('select2-hidden-accessible')){
			var selectToFocus = fieldToFocus.parent().find('.select2.select2-container.select2-container--default.select2-container--focus');
			if (selectToFocus.length>0){
				selectToFocus.focus();
			}
		}else {
			fieldToFocus.focus();
		}
	}

	function validateForm(form) {
		var isValid = true;
		$("input.form-control, select.form-control", form).each(function () {
			if($(this).attr("data-validate-required") === "false") return;
			var currentIsValid = (
				($(this).attr("type") === "email" && isValidEmail($(this).val())) ||
				($(this).attr("type") === "text" && $(this).val() !== '') ||
				($(this).attr("type") === "number" && $(this).val() !== '') ||
				($(this).is("select") && $(this).val() !== '')
			);
			isValid = isValid && currentIsValid;
			if(!currentIsValid) {
				$(this).addClass('is-invalid');
			} else {
				$(this).removeClass('is-invalid');
			}
		});

		return isValid;
	}

	return {
		init: init
	};
})(jQuery);